/**
 * 拼团切换门店
 */
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { deliveryMobx, buyTogetherMobx } from '@mobxStore'
import { Icon } from '@cps'
import './index.scss'

export interface IEatTypeSwitcherProps {
  eatType: TEntryType;
  info: any;
  store: IViewStore;
  onChange: (value: any) => void;
}

const SelectStore: React.FC<IEatTypeSwitcherProps> = (props) => {
  const { viewAddresses } = deliveryMobx
  const { info, store, eatType, onChange } = props

  const handleClick = () => {
    buyTogetherMobx.selectAddress()
  }
  return (
    <div className='multi-spell-address-select-container'>
      <div className='title'><Icon name='mubiao' />{i18n.t('menu.buyTogether.address_delivery')}</div>
      <div className='multi-spell-store-wrapper' onClick={handleClick}>
        {
          info && info.mobile ? (
            <Fragment key='bt-store'>
              <div className='multi-spell-store-wrap'>
                <div className='store-name-wrap'>
                  <span className='store-name'>{info.address}{info.addressDetail}</span>
                </div>
                <div className='store-location'>
                  <span>
                    <span>{info.realName}</span>
                    <span>{info.mobile}</span>
                  </span>
                </div>
              </div>
              <Icon name='change' />
            </Fragment>
          ) : (
            <div className='multi-spell-store-wrap'>
              <div className='store-location'>
                <span className='empty-txt'>{i18n.t('location.chooseYourAddress')}</span>
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default observer(SelectStore)
